import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Button, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Select, Grid, TextField, MenuItem } from "@mui/material";
// components
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";

import axios from "axios";
import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Label from "src/components/Label";
import plusFill from "@iconify/icons-eva/plus-fill";
import Confirm from "src/components/common/ConfirmDialog";
import UserInfo from "src/components/common/UserInfo";
import CellImage from "src/components/common/CellImage";
import RejectApplyDialog from "./components/RejectApplyDialog";
import { asyncRequest } from "src/services/network";
import MerchantApplyEdit from "./components/MerchantApplyEdit";
import MerchantEdit from "./components/MerchantEdit";

const TABLE_HEAD = [{ id: "name", label: "商户名称", alignRight: false }, { id: "realname", label: "法人姓名", alignRight: false }, { id: "mobile", label: "手机号", alignRight: false }, { id: "rangli", label: "让利比例", alignRight: false }, { id: "cardImgFront", label: "身份证正面", alignRight: false }, { id: "cardImgBack", label: "身份证反面", alignRight: false }, { id: "category", label: "分类", alignRight: false }, { id: "license", label: "营业执照", alignRight: false }, { id: "logo", label: "店铺logo", alignRight: false }, { id: "address", label: "地址", alignRight: false }, { id: "type", label: "类型", alignRight: false }, { id: "bankcard", label: "结算卡", alignRight: false }, { id: "uid", label: "推荐人", alignRight: false }, 
{ id: "status", label: "状态", alignRight: false }, 
{ id: "reason", label: "原因", alignRight: false }, 
{ id: "createdAt", label: "创建时间", alignRight: false }, 
{ id: "操作" }];

const moreMenus = [
  { title: "查看", icon: iconEdit2 },
  { title: "通过", icon: iconEdit2 },
  { title: "拒绝", icon: iconEdit2 },
];

export default function MerchantApplyList() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [action, setAction] = useState("");
  const [targetItem, setTargetItem] = useState(null);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/merchant/apply/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      [ki]: val,
      page: 0,
    });
  }

  const handleMoreClick = (type, row) => {
    if (type === "通过") {
      handleAuth(row, 1);
    } else if (type === "拒绝") {
      setTargetItem(row);
      setAction("reject");
    } else if (type === "查看") {
      setTargetItem(row);
      setAction("view");
    }
  };

  function handleAuth({ id }) {
    Confirm({
      message: "确定通过审核吗？",
      async onConfirm() {
        axios
          .post("/merchant/apply/auth", { id, pass: true })
          .then((res) => {
            const { code, msg } = res.data;
            if (code === 1) {
              this.getItems();
              alert(msg, "success");
            } else {
              alert(msg);
            }
          })
          .catch((err) => {});
      },
    });
  }

  async function handleReject(form) {
    if (!form.reason) return alert("请输入拒绝理由");
    const { msg } = await asyncRequest({
      path: "/merchant/apply/auth",
      data: {
        reason: form.reason,
        id: targetItem.id,
        status: 2,
      },
    });

    getItems();
    alert(msg, "success");
    setAction("");
  }

  const isUserNotFound = items.length === 0;

  return (
    <Page title="商户申请">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            商户申请
          </Typography>

          <Button
            variant="contained"
            startIcon={<Icon icon={plusFill} />}
            onClick={() => {
              setAction("add");
            }}
          >
            新增商户入驻
          </Button>
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems}>
            <Grid container>
              {/* <Grid item md={3}>
                <MyDateRangePicker
                  value={filter.createdAt}
                  onChange={(val) => {
                    setFilter({
                      ...filter,
                      createdAt: val,
                    });
                  }}
                />
              </Grid> */}

              <Grid item md={3}>
                <TextField
                  size="small"
                  label="商户名称"
                  placeholder="商户名称"
                  autoComplete="off"
                  id="name"
                  value={filter.name}
                  onChange={(e) => {
                    handleFilterChange("name", e.target.value);
                  }}
                />
              </Grid>

              <Grid item md={3}>
                <TextField
                  size="small"
                  label="法人姓名"
                  placeholder="法人姓名"
                  autoComplete="off"
                  id="realname"
                  value={filter.realname}
                  onChange={(e) => {
                    handleFilterChange("realname", e.target.value);
                  }}
                />
              </Grid>

              <Grid item md={3}>
                <TextField
                  size="small"
                  label="手机号"
                  placeholder="手机号"
                  autoComplete="off"
                  id="mobile"
                  value={filter.mobile}
                  onChange={(e) => {
                    handleFilterChange("mobile", e.target.value);
                  }}
                />
              </Grid>

              <Grid item md={6}>
                <Select value={filter.status} onChange={(e) => handleFilterChange("status", e.target.value)} style={{ width: 250, height: 44 }}>
                  {[0, 1, 2].map((status, idx) => (
                    <MenuItem key={status} value={status}>
                      {["待审核", "已通过", "已拒绝"][status]}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
          </ListToolbar>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { id, uid, name, license, user, cardImgFront, cardImgBack, mobile, realname, createdAt, status, category, logo, address, type, bankcard, rangli, reason } = row;
                    const isItemSelected = selected.indexOf(realname) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                        {/* <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, uid)}
                            />
                          </TableCell> */}

                        <TableCell align="left">{name}</TableCell>
                        <TableCell align="left">{realname}</TableCell>
                        <TableCell align="left">{mobile}</TableCell>
                        <TableCell align="left">{rangli}%</TableCell>
                        <TableCell align="left">
                          <CellImage src={cardImgFront} />
                        </TableCell>
                        <TableCell align="left">
                          <CellImage src={cardImgBack} />
                        </TableCell>
                        <TableCell align="left">{category ? category.name : ""}</TableCell>
                        <TableCell align="left">
                          <CellImage src={license} />
                        </TableCell>
                        <TableCell align="left">
                          <CellImage src={logo} />
                        </TableCell>
                        <TableCell align="left">{address}</TableCell>
                        <TableCell align="left">{["个体工商户", "企业"][type]}</TableCell>
                        <TableCell align="left">
                          <CellImage src={bankcard} />
                        </TableCell>
                        <TableCell align="left">
                          <UserInfo {...user} />
                        </TableCell>

                        <TableCell align="left">
                          <Label color={["error", "success", "default"][status]}>{["待审核", "已通过", "已拒绝"][status]}</Label>
                        </TableCell>
                        <TableCell align="left">{reason}</TableCell>
                        <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                        <TableCell align="right">
                          <MoreMenu menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>

      {action == "reject" && <RejectApplyDialog open onClose={() => setAction("")} onConfirm={handleReject} />}
      {(action == "add" || action == "edit") && <MerchantApplyEdit item={targetItem} open onClose={() => setAction("")} onConfirm={() => {}} />}
      {action == "view" && <MerchantApplyEdit readonly item={targetItem} open onClose={() => setAction("")} onConfirm={() => setAction("")} />}
    </Page>
  );
}
